import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000,
});
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.common['Authorization'] = `Bearer ${getToken()}`;
    }
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status !== 200 && response.status !== 201) {
      if (res.code === 401) {
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload();
          });
        });
      }
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  (error) => {
    if (error.message.match('401')) {
      error.message = '登入錯誤';
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    });
    store.dispatch('user/resetToken').then(() => {
      // window.location.href = '/login'
    });
    return Promise.reject(error);
  },
);

export default service;
